import { render, staticRenderFns } from "./BatchApprove.vue?vue&type=template&id=7fc5c16a&"
import script from "./BatchApprove.vue?vue&type=script&lang=js&"
export * from "./BatchApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fc5c16a')) {
      api.createRecord('7fc5c16a', component.options)
    } else {
      api.reload('7fc5c16a', component.options)
    }
    module.hot.accept("./BatchApprove.vue?vue&type=template&id=7fc5c16a&", function () {
      api.rerender('7fc5c16a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/batches/views/components/modals/BatchApprove.vue"
export default component.exports